/**
 * Build metadata object for join-process log entries.
 * @param {Object} options
 * @param {string} options.provider - 'agora' (other providers deferred to follow-up)
 * @param {string|number|null} options.lessonId - current lesson ID (omitted if falsy)
 * @param {Object} [options.extra] - additional metadata to merge
 * @returns {Object} metadata for logger call
 */
export function buildJoinMeta({ provider, lessonId, extra = {} }) {
  const meta = { operation: 'webrtc:join', provider, ...extra };
  if (lessonId) {
    meta.lesson_id = lessonId;
  }
  return meta;
}

/**
 * Build the [WebRTC:Join][<tag>] prefix string.
 * @param {string} adapterTag - e.g. 'Agora', 'RtcClient', 'VideoChat'
 * @returns {string}
 */
export function joinPrefix(adapterTag) {
  return `[WebRTC:Join][${adapterTag}]`;
}
